// Copyright (c) 2022-2023. Heusala Group Oy <info@heusalagroup.fi>. All rights reserved.

import { useAuthSession } from "../../../../../../../io/hyperify/frontend/hooks/useAuthSession";
import { MY_ORDER_VIEW_CLASS_NAME } from "../../../../../core/constants/className";
import { useShoppingCart } from "../../../../../../../io/hyperify/frontend/hooks/useShoppingCart";
import { MyOrderNoCartArticle } from "./MyOrderNoCartArticle";
import { MyOrderAuthorizedArticle } from "./MyOrderAuthorizedArticle";
import { MyLoginArticle } from "../unauthorized/MyLoginArticle";
import { T_MY_ORDER_VIEW_REQUEST_CODE_TITLE, T_MY_ORDER_VIEW_REQUEST_TEXT, T_MY_ORDER_VIEW_LOGIN_SUBMIT_BUTTON_LABEL, T_MY_ORDER_VIEW_LOGIN_TEXT, T_MY_ORDER_VIEW_LOGIN_TITLE } from "../../../../../core/constants/translation";
import { TranslationFunction } from "../../../../../../../io/hyperify/core/types/TranslationFunction";

export interface MyOrderViewProps {
    readonly className?: string;
    readonly t: TranslationFunction;
}

export function MyOrderView (props: MyOrderViewProps) {
    const className = props?.className;
    const t = props?.t;
    // We should not listen cart events here, otherwise order completion will
    // not be shown here
    const [cart/*, refreshCart*/] = useShoppingCart();
    const cartItemsCount = cart?.items?.length ?? 0;
    const session = useAuthSession();
    const translationParams = {};
    return (
        <div
            className={
                MY_ORDER_VIEW_CLASS_NAME
                + (className ? ` ${className}` : '')
            }
        >{cartItemsCount === 0 ? (
            <MyOrderNoCartArticle t={t} />
        ) : (
            session?.isLoggedIn ? (
                <MyOrderAuthorizedArticle t={t} session={session} />
            ) : (
                <MyLoginArticle
                    t={t}
                    title={t(T_MY_ORDER_VIEW_LOGIN_TITLE, translationParams)}
                    contentText={t(T_MY_ORDER_VIEW_LOGIN_TEXT, translationParams)}
                    submitButtonLabel={t(T_MY_ORDER_VIEW_LOGIN_SUBMIT_BUTTON_LABEL, translationParams)}
                    requestCodeTitle={t(T_MY_ORDER_VIEW_REQUEST_CODE_TITLE, translationParams)}
                    requestCodeText={t(T_MY_ORDER_VIEW_REQUEST_TEXT, translationParams)}
                />
            )
        )}</div>
    );
}
